<template>
  <div>
    <div class="text-lg font-bold">Характеристики</div>
    <div v-if="props.miniMode">
      <div class="max-h-[180px] overflow-hidden">
        <ProductCharacteristicTable :characteristic="characteristicFirstCol">
        </ProductCharacteristicTable>
      </div>
      <div v-if="props.characteristic.length > miniModeCount">
        <button @click="emit('read-full')" class="text-blue-600">Все характеристики</button>
      </div>
    </div>
    <div v-else>
      <div class="grid grid-cols-[1fr_1fr] items-start">
        <ProductCharacteristicTable :characteristic="characteristicFirstCol">
        </ProductCharacteristicTable>
        <ProductCharacteristicTable :characteristic="characteristicSecCol">
        </ProductCharacteristicTable>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import { type TProductCharacteristic } from '@/types/book_item'
import ProductCharacteristicTable from '@/components/product/ProductCharacteristicTable.vue'

const props = defineProps<{
  characteristic: TProductCharacteristic[]
  miniMode?: boolean
}>()
const emit = defineEmits<{
  (e: 'read-full'): void
}>()

const miniModeCount = 3

const halfIndex = Math.ceil(props.characteristic.length / 2)

const characteristicFirstCol = computed<TProductCharacteristic[]>(() => {
  const items: TProductCharacteristic[] = []
  if (props.miniMode) {
    for (let i = 0; i < ((props.characteristic.length > miniModeCount - 1) ? miniModeCount : props.characteristic.length); i++) {
      items.push(props.characteristic[i])
    }
    return items;
  }

  for (let i = 0; i < halfIndex; i++) {
    items.push(props.characteristic[i])
  }
  return items
})

const characteristicSecCol = computed<TProductCharacteristic[]>(() => {
  if (props.miniMode) {
    return [];
  }
  const items: TProductCharacteristic[] = []
  for (let i = halfIndex; i < props.characteristic.length; i++) {
    items.push(props.characteristic[i])
  }
  return items
})
</script>
